import { render, staticRenderFns } from "./rubric_builder_create_header.vue?vue&type=template&id=6ec670b5&scoped=true&"
import script from "./rubric_builder_create_header.vue?vue&type=script&lang=js&"
export * from "./rubric_builder_create_header.vue?vue&type=script&lang=js&"
import style0 from "./rubric_builder_create_header.vue?vue&type=style&index=0&id=6ec670b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec670b5",
  null
  
)

export default component.exports